import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { lastValueFrom } from 'rxjs';
import { BusyIndicatorMessageManager } from '../../../Busy-Indicator';
import { LeadDocketLogRepository } from '../leadDocketLog.repository';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { LeadDocketLogDetailsGridComponent } from './leadDocketLogDetailsGrid.component';

export interface LeadDocketLogDetailsParams {
    summaryLogId: number;
}

@Component({
    selector: 'lead-docket-log-details-modal',
    templateUrl: './leadDocketLogDetailsModal.component.html',
    styleUrls: ['./leadDocketLogDetailsModal.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class LeadDocketLogDetailsModalComponent implements OnInit, IWeissmanModalComponent<LeadDocketLogDetailsParams, void> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _leadDocketLogRepository: LeadDocketLogRepository) {
    }

    @ViewChild('leadDocketLogDetailsGrid') leadDocketLogDetailsGrid: LeadDocketLogDetailsGridComponent;

    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();

    params: LeadDocketLogDetailsParams;
    result: void;

    leadDocketDiagnosticsDetail: Core.LeadDocketDiagnosticsDetailModel;

    async ngOnInit(): Promise<void> {
        const busyMsgId = 'loading';
        this.busyIndicatorMessageManager.add('Loading Lead Docket Log Details', busyMsgId);

        const searchParams: Core.LeadDocketDiagnosticsDetailSearchModel = {
            summaryLogId: this.params.summaryLogId
        };

        try {
            this.leadDocketDiagnosticsDetail = await lastValueFrom(this._leadDocketLogRepository.getDetail(searchParams));
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    cancel(): void {
        this._bsModalRef.hide();
    }
}
